import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=93cd3976&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=93cd3976&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cd3976",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContextSwitcher: require('/app/components/Layout/Sidebar/ContextSwitcher.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,SidebarItem: require('/app/components/Layout/Sidebar/SidebarItem.vue').default,SidebarCollapsible: require('/app/components/Layout/Sidebar/SidebarCollapsible.vue').default,SidebarItemGroup: require('/app/components/Layout/Sidebar/SidebarItemGroup.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,DeepSourceLogo: require('/app/components/DeepSourceLogo.vue').default,TrialCard: require('/app/components/Layout/Sidebar/TrialCard.vue').default,WhatsNewCard: require('/app/components/Layout/Sidebar/WhatsNewCard.vue').default,StarterMigrateCard: require('/app/components/Layout/Sidebar/StarterMigrateCard.vue').default,UserMenu: require('/app/components/Layout/Sidebar/UserMenu.vue').default,AddRepoModal: require('/app/components/AddRepo/AddRepoModal.vue').default,MigrateTeamPlanModal: require('/app/components/Billing/Modals/MigrateTeamPlanModal.vue').default})
